export const NEWS = 'NEWS';



// WEBPACK FOOTER //
// ./src/store/modules/news/mutation-types.js